var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.909,
    height: 40,
    viewBox: "0 0 50.909 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "black-back-closed-envelope-shape",
    transform: "translate(0 -59.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(0 59.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M61.743,339.077a4.351,4.351,0,0,0,2.979-1.124L50.3,323.529c-.346.248-.681.489-1,.718q-1.619,1.193-2.628,1.86a16.193,16.193,0,0,1-2.685,1.364,8.182,8.182,0,0,1-3.125.7h-.057a8.18,8.18,0,0,1-3.125-.7A16.141,16.141,0,0,1,35,326.107q-1.009-.667-2.628-1.861c-.3-.221-.635-.463-1-.722L16.946,337.953a4.352,4.352,0,0,0,2.979,1.124Z",
    transform: "translate(-15.38 -299.077)",
    fill: "#b9ab9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M2.87,201.027A15.061,15.061,0,0,1,0,198.555V220.5l12.713-12.713Q8.9,205.124,2.87,201.027Z",
    transform: "translate(0 -185.657)",
    fill: "#b9ab9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M423.176,201.027q-5.8,3.929-9.867,6.765L426.017,220.5V198.555A15.678,15.678,0,0,1,423.176,201.027Z",
    transform: "translate(-375.108 -185.657)",
    fill: "#b9ab9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M46.369,59.013H4.551A4.057,4.057,0,0,0,1.185,60.49,5.732,5.732,0,0,0,.006,64.183a6.639,6.639,0,0,0,1.562,3.878,14.094,14.094,0,0,0,3.324,3.281q.966.682,5.824,4.048c1.748,1.212,3.269,2.268,4.576,3.179,1.114.776,2.074,1.448,2.867,2.006l.424.3.783.564q.923.668,1.534,1.08t1.477.923a8.619,8.619,0,0,0,1.634.767,4.52,4.52,0,0,0,1.42.256h.057a4.522,4.522,0,0,0,1.42-.256,8.6,8.6,0,0,0,1.634-.767q.866-.512,1.478-.923t1.534-1.08c.319-.231.578-.418.783-.564l.425-.3,2.875-2q3.533-2.455,10.421-7.235a13.512,13.512,0,0,0,3.466-3.494,7.516,7.516,0,0,0,1.391-4.289,4.583,4.583,0,0,0-4.546-4.546Z",
    transform: "translate(-0.005 -59.013)",
    fill: "#b9ab9d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.19e3a3bc7637fa01ff48b9f84490cfaa.svg";
export { ForwardRef as ReactComponent };